// extracted by mini-css-extract-plugin
export default {"fileDropWrap":"FileDrop_fileDropWrap__Ga6PZ","dragInfoWrap":"FileDrop_dragInfoWrap__vW2C6"};